// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stack {
  display: flex;
  flex-direction: column;
}

  .stack--xsmall {
    gap: calc(.25rem);
  }

  .stack--small {
    gap: calc(.5rem);
  }

  .stack--medium {
    gap: 1rem;
  }

  .stack--large {
    gap: calc(1.5rem);
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
